export default __webpack_public_path__ + "static/media/modal-image.925de896.png";